import React from 'react';
import { faArrowsRepeat } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function ArrowsRepeatRegularIcon(props) {
  return <FontAwesomeIcon icon={faArrowsRepeat} {...props} />;
}
